import './programpagectrl.js';
import './studentprofilemodal.js';

import 'Sass/views/program-item.scss';